import GiftSummaryPage from "./GiftSummaryPage";

export default GiftSummaryPage;
